import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalPortal } from '@/presentation/components/common/ModalPortal';
import { useAuth } from '@/presentation/contexts/useAuth';

/** Pantalla bloqueada post-login cuando no hay clínicas: solo cartel + Salir. */
export function EmptyScopeShell() {
  const { t } = useTranslation();
  const { logout } = useAuth();

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return (
    <ModalPortal>
      <div
        data-testid="empty-scope-block"
        className="fixed inset-0 z-[9999] flex items-center justify-center p-6"
        aria-hidden={false}
      >
        <div
          data-testid="empty-scope-backdrop"
          className="absolute inset-0 bg-slate-900/60 backdrop-blur-lg dark:bg-black/75"
          aria-hidden="true"
        />

        <div
          data-testid="no-clinic-scope-empty"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="empty-scope-title"
          aria-describedby="empty-scope-description"
          className="relative z-10 w-full max-w-md rounded-2xl border border-slate-200/80 bg-white p-6 text-center shadow-2xl dark:border-gray-700 dark:bg-slate-900"
        >
          <h1 id="empty-scope-title" className="text-xl font-bold text-slate-900 dark:text-white">
            {t('scope.empty.title')}
          </h1>
          <p id="empty-scope-description" className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            {t('scope.empty.message')}
          </p>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">{t('scope.empty.contact')}</p>
          <button
            type="button"
            onClick={logout}
            className="mt-6 inline-flex min-h-10 w-full items-center justify-center rounded-xl bg-teal-600 px-4 text-sm font-semibold text-white transition hover:bg-teal-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900"
          >
            {t('auth.logout')}
          </button>
        </div>
      </div>
    </ModalPortal>
  );
}
